
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { TestId } from '@owc-utils/TestIdDirective';
import { FeatureItemComponent } from './FeatureBoxItem';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src/ValidationBoxWrapper.vue';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

export default (ComponentInitializeDispatcher as FeatureItemComponent).extend({
  name: 'owc-feature-box-item',
  directives: {
    TestId,
  },
  components: {
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent],
  computed: {
    subtitle() {
      return this.componentData?.subtitle;
    },
    value() {
      return this.componentData?.value;
    },
    unit() {
      return this.componentData?.unit;
    },
    description() {
      return this.componentData?.description;
    },
  },
});
